__turbopack_context__.v({
  "bannerText": "fOOyla_bannerText",
  "body1": "fOOyla_body1",
  "body2": "fOOyla_body2",
  "heading": "fOOyla_heading",
  "linkButton": "fOOyla_linkButton",
  "sectionPadding": "fOOyla_sectionPadding",
  "subHeading1": "fOOyla_subHeading1",
  "subHeading2": "fOOyla_subHeading2",
});
